@switch (currentStage()) {
  @case ('Select') {
    <div class="dialog-content-container p-4">
      <div class="dialog-content mx-auto">
          <div class="subtext">{{ 'REVERT_QUOTE.SUBTEXT' | translate }}</div>
          <ng-container [formGroup]="form">
            <div class="flex flex-column gap-4">
              <!-- Send Mail Toggle (only show if under review) -->
              @if (form.controls['sendMail']) {
                <div class="flex align-items-center gap-3">
                  <p-toggleswitch
                    [ngModel]="sendMailEnabled()"
                    (ngModelChange)="onSendMailChange($event)"
                    [ngModelOptions]="{ standalone: true }"
                    inputId="sendMail"
                  />
                  <label for="sendMail">{{ 'REVERT_QUOTE.SHOULD_SEND_MAIL' | translate }}</label>
                </div>
              }

              @if (sendMailEnabled()) {
                <!-- Recipient Email -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <input id="recipientEmail" pInputText formControlName="recipientEmail" class="w-full" />
                            <label for="recipientEmail">{{ "QUOTE.DETAIL.QUOTE_INFORMATION.SEND_TO" | translate }} *</label>
                        </p-floatlabel>
                    </p-inputgroup>
                    <app-core-errors [control]="form.get('recipientEmail')"></app-core-errors>
                </div>

                <!-- CC Emails -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <input
                                id="ccEmail"
                                pInputText
                                [formControl]="ccEmailControl"
                                (keydown.enter)="addCcRecipient(); $event.preventDefault()"
                                (blur)="addCcRecipient()"
                                class="w-full"
                            />
                            <label for="ccEmail">{{ "QUOTE.DETAIL.QUOTE_INFORMATION.SEND_COPY_TO" | translate }}</label>
                        </p-floatlabel>
                    </p-inputgroup>
                    <app-core-errors [control]="ccEmailControl"></app-core-errors>
                    @if (validCcEmails.length > 0) {
                        <div class="flex flex-wrap gap-2 mt-2">
                            @for (email of validCcEmails; track email) {
                                <p-chip [label]="email" [removable]="true" (onRemove)="removeCcRecipient(email)" />
                            }
                        </div>
                    }
                </div>

                <!-- Message -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <textarea
                                id="message"
                                pTextarea
                                formControlName="message"
                                [rows]="4"
                                [autoResize]="true"
                                class="w-full"
                            ></textarea>
                            <label for="message">{{ "SEND_QUOTE.LBL_MESSAGE" | translate }}</label>
                        </p-floatlabel>
                    </p-inputgroup>
                </div>
              }

              <!-- Comment (always shown) -->
              <div>
                <p-inputgroup>
                  <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
                  <p-floatlabel variant="on" class="flex-1">
                    <textarea
                      id="comment"
                      pTextarea
                      formControlName="comment"
                      (keydown)="overrideSubmit($event)"
                      [rows]="5"
                      class="w-full"
                    ></textarea>
                    <label for="comment">{{ 'REVERT_QUOTE.LABEL' | translate }} *</label>
                  </p-floatlabel>
                </p-inputgroup>
              </div>
            </div>
            <!-- Actions -->
            <div class="flex justify-content-end gap-2 mt-4">
              <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="closeDialog()" />
              <p-button
                [label]="'REVERT_QUOTE.CONFIRM_BTN' | translate"
                (onClick)="confirm()"
                [disabled]="form.invalid"
              />
            </div>
          </ng-container>
        </div>
    </div>
  }
  <!-- Confirmation -->
  @case ('Confirmation') {
    <div class="dialog-content-container">
      <div class="response-container">
        <i class="pi pi-check-circle text-4xl text-green-500 mb-3"></i>
        <span class="response-title">{{ 'REVERT_QUOTE.CREATED.TITLE' | translate }}</span>
        <span class="response-text">{{ 'REVERT_QUOTE.CREATED.TEXT' | translate }}</span>
        <!-- Actions -->
        <div class="flex justify-content-end gap-2 mt-4">
          <p-button [label]="'CLOSE' | translate" [text]="true" (onClick)="closeDialog()" />
        </div>
      </div>
    </div>
  }
  <!-- Error -->
  @case ('Error') {
    <div class="dialog-content-container">
      <div class="response-container">
        <i class="pi pi-exclamation-circle text-4xl text-red-500 mb-3"></i>
        <span class="response-title">{{ 'REVERT_QUOTE.ERROR.TITLE' | translate }}</span>
        <span class="response-text">
          <b>{{ 'REVERT_QUOTE.ERROR.PREFIX' | translate }}:</b>
        </span>
        <!-- Actions -->
        <div class="flex justify-content-end gap-2 mt-4">
          <p-button [label]="'CLOSE' | translate" [text]="true" (onClick)="closeDialog()" />
        </div>
      </div>
    </div>
  }
}
